import script from "./fileUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUploader.vue?vue&type=script&setup=true&lang=js"

import "./fileUploader.vue?vue&type=style&index=0&id=17d2f824&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d2f824"]])

export default __exports__